import React, { useEffect, useMemo, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import img1 from '../images/lucky.png'
import charmImage from '../images/charm.png';
import { useLotteryData } from '../data/useLotteryData';
import {
  estimateStateTakeHome,
  isStateCode,
  STATE_SELECTION_KEY,
  US_STATES
} from '../data/stateTaxes';

function Powerball(props) {
    const navigate = useNavigate();
    const [selectedState, setSelectedState] = useState(readSelectedState);
    const [charmBurst, setCharmBurst] = useState(0);

    useEffect(() => {
      try {
        window.localStorage.setItem(STATE_SELECTION_KEY, selectedState);
      } catch {
        // The selector still works when browser storage is unavailable.
      }
    }, [selectedState]);

    function handleButtonClick() {
      navigate(props.select.classCalled === "megaImage" ? "/tellmemoremega" : "/tellmemorepower");
    }

    function handleBackClick() {
      navigate('/');
    }

    const game = props.select.classCalled === 'megaImage' ? 'mega-millions' : 'powerball';
    const { data: responseData, loading } = useLotteryData(game);
    const apiData = useMemo(() => {
        let lotteryData = []
        if(responseData?.PreviousDraws?.length) {
            let result = "";
              for (let i = 0; i < 6; i++) {
                if (i === 5) {
                  result += "<b>" + responseData.PreviousDraws[0].WinningNumbers[i].Number + "</b> ";
                } else {
                  result += responseData.PreviousDraws[0].WinningNumbers[i].Number + '&nbsp&nbsp&nbsp'; ;
                }
              }
            lotteryData.push(result)
            lotteryData.push(formatCurrency(responseData.NextDraw.JackpotAmount));
            lotteryData.push(formatCurrency(responseData.NextDraw.EstimatedCashValue));
            lotteryData.push(formatCurrency(responseData.NextDraw.EstimatedCaliforniaTakeHome));
            let DrawDate = responseData.NextDraw.DrawDate
            let LastDrawDate = responseData.PreviousDraws[0].DrawDate
            let pushPower = new Date(DrawDate)
            let LastDrawData = new Date(LastDrawDate)
            lotteryData.push(pushPower.toLocaleString('en-US', {month: 'long', day: 'numeric', hour: 'numeric', timeZone: 'America/Los_Angeles'}))
            lotteryData.push(LastDrawData.toLocaleString('en-US', {month: 'long', day: 'numeric'}))
        }
        return lotteryData;
    }, [responseData]);
    const cashValue = responseData?.NextDraw?.EstimatedCashValue;
    const federalTax = Number.isFinite(responseData?.NextDraw?.EstimatedFederalTax)
      ? responseData.NextDraw.EstimatedFederalTax
      : cashValue - responseData?.NextDraw?.EstimatedCaliforniaTakeHome;
    const selectedStateTakeHome = useMemo(() => {
      return estimateStateTakeHome(cashValue, federalTax, selectedState);
    }, [cashValue, federalTax, selectedState]);
    const selectedStateName = US_STATES.find(
      (state) => state.code === selectedState
    )?.name ?? 'California';

    function handleStateChange(event) {
      const nextState = event.target.value;
      const nextTakeHome = estimateStateTakeHome(cashValue, federalTax, nextState);
      if (
        nextState !== selectedState &&
        Number.isFinite(nextTakeHome) &&
        nextTakeHome === selectedStateTakeHome
      ) {
        setCharmBurst((burst) => burst + 1);
      } else {
        setCharmBurst(0);
      }
      setSelectedState(nextState);
    }

      return (
        <div className="wrapper">
          <div className="headerWrapper">
            <Link to="/"><img className={props.select.classCalled} src={props.select.image} width={props.select.imageWidth} height={props.select.imageHeight} alt={'main'}/></Link>
            <div className="numberClass" dangerouslySetInnerHTML={{__html: apiData[0]}}></div>
            <div className="dateClass">{apiData[5]}</div>
          </div>
          {(() => {
            if (loading) {
              return <div className="loadingContainer"><img src={img1} alt={'loading'} className="luckyNumbers spinAnimation" /></div>
            } else {
              return (
                <div className="container">
                    <div>
                    <p className="tableTextStyle">Jackpot: <span style={{ color: 'green' }}><b>{apiData[1]}</b></span></p>
                    <p className="tableTextStyle" title="Official lump-sum cash option published by the lottery">Cash Value: {apiData[2]}</p>
                    <p className="tableTextStyle takeHomeRow" title="Estimated cash option after 2026 federal and selected-state taxes; local taxes excluded">
                      <span>Take Home</span>
                      <span className="stateSelectWrapper">
                        <span aria-hidden="true" className="stateSelectMeasure">
                          {selectedStateName}
                        </span>
                        <select
                          aria-label="Take home state"
                          className="stateSelect"
                          value={selectedState}
                          onChange={handleStateChange}
                        >
                          {US_STATES.map((state) => (
                            <option key={state.code} value={state.code}>{state.name}</option>
                          ))}
                        </select>
                        <span aria-hidden="true" className="stateSelectCaret stateSelectCaretVisible" />
                      </span>
                      <span className="takeHomeAmount">: <span className="takeHomeValue">
                          {formatCurrency(selectedStateTakeHome)}
                          {charmBurst > 0 && (
                            <span
                              aria-hidden="true"
                              className="luckyCharmBurst"
                              key={charmBurst}
                              onAnimationEnd={() => setCharmBurst(0)}
                            >
                              <img alt="" className="luckyCharmBurstImage" src={charmImage} />
                            </span>
                          )}
                        </span>
                      </span>
                    </p>
                    </div>
                    <div>
                    <p className="tableTextStyle">Next Drawing: {apiData[4]}</p>
                    <div className="summaryActionButtons">
                      <button className="tableTextStyle" onClick={handleButtonClick}>Tell Me More</button>
                      <button className="tableTextStyle summaryBackButton" onClick={handleBackClick}>Back</button>
                    </div>
                    </div>
                </div>
              );
            }
          })()}
        </div>
      );
}

export default Powerball

function formatCurrency(value) {
  return Number.isFinite(value)
    ? value.toLocaleString('en-US', {style: 'currency', currency: 'USD'}).replaceAll(' ', '').replace(/\.00$/, '')
    : '';
}

function readSelectedState() {
  try {
    const storedState = window.localStorage.getItem(STATE_SELECTION_KEY);
    return isStateCode(storedState) ? storedState : 'CA';
  } catch {
    return 'CA';
  }
}
